import { Component, Input, OnInit } from '@angular/core';


import * as Highcharts from 'highcharts';

declare var require: any;
const More = require('highcharts/highcharts-more');
More(Highcharts);

import Histogram from 'highcharts/modules/histogram-bellcurve';
Histogram(Highcharts);

import highcharts3D from 'highcharts/highcharts-3d';
highcharts3D(Highcharts);

import Cylinder from 'highcharts/modules/cylinder';
import { Options } from '@angular-slider/ngx-slider';
import { UtilService } from 'src/app/services/util.service';
Cylinder(Highcharts);

const Exporting = require('highcharts/modules/exporting');
Exporting(Highcharts);

const ExportData = require('highcharts/modules/export-data');
ExportData(Highcharts);

const Accessibility = require('highcharts/modules/accessibility');
Accessibility(Highcharts);

@Component({
  selector: 'app-tank-charts',
  templateUrl: './tank-charts.component.html',
  styleUrls: ['./tank-charts.component.css']
})
export class TankChartsComponent implements OnInit {

  public activity;
  public xData;
  public label;
  public fillWithGradient;
  public colorCodes = {
    "regular" : "#fbefc2",
    "super" : "red",
    "plus" : "blue",
    "uls" : "yellow",
    "dyed" : "#61e623",
    "misc" : "black"
}
  @Input() set data(data: any) {
    console.log("tANK DATA", data);
    this.backedupData = data;
    this.updateChart(data);
  }
  @Input() set gradientFill(gradientFill: boolean) {
    this.fillWithGradient = gradientFill;
    this.updateChart(this.backedupData);
  }
  options: any;
  value: number = 100;
  showHide = false;
  sliderOptions: Options = {
    floor: 0,
    ceil: 200
  };
  verticalSliderOptions: Options = {
    floor: 0,
    ceil: 200,
    vertical: true
  };
  chart;
  backedupData;

  constructor(private utilService: UtilService) {
    this.initializeHighjs();
  }

  ngOnInit(): void {
    this.chart = Highcharts.chart('cylinderchart', this.options);
    const updateButton = document.querySelector('#update');
  }


  initializeHighjs() {

    this.options = {
      chart: {
        type: 'column',
        animation: true,
        options3d: {
          enabled: true,
          alpha: 0,
          beta: 0,
          viewDistance: 25,
          depth: 40
        }
      },

      title: {
        text: ''
      },

      xAxis: {
        categories: [],
        labels: {
          skew3d: true,
          style: {
            fontSize: '12px'
          }
        }
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Gallons',
          skew3d: true
        }
      },

      tooltip: {
        headerFormat: '<b>{point.key}</b><br>',
        pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: {point.y} / {point.stackTotal}'
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          depth: 40
        }
      },

      series: [
        {
          showInLegend: false,
          name: 'Empty',
          data: [],
          stack: 'tank'
        },
        {
          showInLegend: false,
          name: '90% Ullage Capacity',
          data: [],
          stack: 'tank'
        }, {
          showInLegend: false,
          name: 'Gallons',
          data: [],
          stack: 'tank'
        }, {
          showInLegend: false,
          name: 'water',
          data: [],
          stack: 'tank'
        }],

        exporting: {
          enabled: false,
          showTable: false
      },

        
  responsive: {
    rules: [{
      condition: {
        maxWidth: 1000
      },
      chartOptions: {
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal'
        },
        yAxis: {
          labels: {
            align: 'left',
            x: 0,
            y: -5
          },
          title: {
            text: null
          }
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        }
      }
    }]
  }
    }

  }



  rotateChart(alpha?, beta?, distance?) {

    console.log("Redraw", alpha)
    if (alpha) {
      this.options.chart.options3d.alpha = alpha?.value;
    } if (beta) {
      this.options.chart.options3d.beta = beta?.value;
    } if (distance) {
      this.options.chart.options3d.viewDistance = distance;
    }

    this.chart = Highcharts.chart('cylinderchart', this.options);
    this.updateChart(this.backedupData);
  }

  findColor(product) {
    product = product.toLowerCase();
    let colorCode;
    if (product.includes('reg')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f6f9fb'],
            [1, '#ebecf3']
          ]
        };
      } else {
        colorCode = '#fafbcd';
      }
    } else if (product.includes('premium') || product.includes('super')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f47a0f'],
            [1, '#ee220d']
          ]
        };
      } else {
        colorCode = '#bd0a0a';
      }
    } else if (product.includes('mid')) {
      colorCode = '#92d4f3'
    } else if (product.includes('uls')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#f4f812'],
            [1, '#d5ee07']
          ]
        };
      } else {
        colorCode = '#fbef60';
      }
    } else if (product.includes('plus')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, '#93c7e6'],
            [1, '#a0a4f5']
          ]
        };
      } else {
        return 'yellow';
      }
    } else if (product.includes('ullage')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, 'rgb(255, 255, 255, 0.5)'],
            [1, 'rgb(200, 200, 200, 0.5)']
          ]
        };
      } else {
        colorCode = '#8db7f64d';
      }
    } else if (product.includes('capacity')) {
      if (this.fillWithGradient) {
        colorCode = {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1
          },
          stops: [
            [0, 'rgb(255, 255, 255, 0.5)'],
            [1, 'rgb(200, 200, 200, 0.5)']
          ]
        };
      } else {
        colorCode = '#8db7f65e';
      }
    } else {
      colorCode = 'black';
    }
    
    return colorCode;
  }

  updateChart(data, animate = true) {

    if (this.chart) {
      const ullageSeries = this.chart.series[1];
      const gallonsSeries = this.chart.series[2];
      const waterSeries = this.chart.series[3];
      const capacitySeries = this.chart.series[0];
      const labels = this.chart.xAxis[0];

      const ullageSeriesData = [];
      const gallonSeriesData = [];
      const waterSeriesData = [];
      const capacityData = [];
      let categories = [];

      data?.tblTanks?.forEach(tblTank => {
        // ullageSeriesData.push({y: tblTank.ullage * tblTank.tankSize, color: '#8db7f64d'});
        capacityData.push({
          y: (tblTank.tankSize) - (tblTank.ullage * tblTank.tankSize),
          color: this.findColor('capacity')
        });
        ullageSeriesData.push({
          y: (tblTank.ullage * tblTank.tankSize) - (tblTank.lastInventory),
          color: this.findColor('ullage')
        });
        gallonSeriesData.push({ y: tblTank.lastInventory, color: this.colorCodes[this.utilService.selectClass(tblTank?.displayCode? tblTank?.displayCode : tblTank?.tankName)] });
        waterSeriesData.push({ y: (tblTank.lastWater ? tblTank.lastWater : null), color: '#1a5c96' });
        categories.push(tblTank.tankName);
      });

      labels.update({
        categories: categories
      });

      capacitySeries.update({
        data: capacityData
      });

      ullageSeries.update({
        data: ullageSeriesData
      });

      gallonsSeries.update({
        data: gallonSeriesData
      });

      waterSeries.update({
        data: waterSeriesData
      });
    }
  }

}
